module.exports = __webpack_public_path__ + "img/12.b6278c07.png";